import { DateTime } from 'luxon';
import React from 'react';
import { ANNOTATION_TABLE_DEFAULT } from '../utils/diagnostic.factory';
import { Tag, Text, HStack } from '@cdl/heartbeat-react';

interface Props {
  updatedAt: string;
  annotationTable: string;
  pipeline: string;
}

export const DiagnosticInformation: React.FC<Props> = ({
  updatedAt,
  annotationTable,
  pipeline,
}) => {
  return (
    <HStack justifyContent='space-between'>
      <Text fontSize='xs' data-testid='annotation-table'>
        {DateTime.fromISO(updatedAt).toLocaleString()} |{' '}
        {annotationTable ?? ANNOTATION_TABLE_DEFAULT}
      </Text>
      {pipeline === 'immutable' && (
        <Tag bg='primary.500' size='sm' color='neutral.0'>
          FROZEN
        </Tag>
      )}
    </HStack>
  );
};
